<template>
  <SOSlotModal
      modal-title="Pilih Outlet"
      :modal-id="id"
      :no-padding="true"
      @close="close"
  >
    <template v-slot:modal-body>
      <div class="list-wrapper">

          <SOInputRadioSlot
              v-for="o in outlet"
              :key="o.idoutlet"
              name="outlet"
              :id="o.idoutlet"
              :value="o.idoutlet"
              :radio-selected="idOutletSelected"
              @selected-radio="(val) => golistmesin(val)"
          >
            <template v-slot:content>
              <div class="content-radio">
                <div v-if="o.logo_url === '' || o.logo_url == null">
                  <img src="@/assets/gambar/Rectangle43.svg" alt=""
                       class="logo"
                       id="logo"/>
                </div>
                <div v-else>
                  <img class="logo"
                       v-if="o.logo_url.includes('bos_revamp/')"
                       v-bind:src="'https://storage.googleapis.com/ember-e-dalbo/'+ o.logo_url"
                       alt=""
                       id="logo"/>
                  <img class="logo"
                       v-else
                       v-bind:src="'https://res.cloudinary.com/sinadme/c_scale,h_200/'+ o.logo_url"
                       alt=""
                       id="logo"/>
                </div>
                <div class="radio-slot-text">
                  <div class="f-c-black f-regular f-16">{{ o.nama }}</div>
                  <div class="f-c-midgrey f-regular f-13">{{ o.alamat }}</div>
                </div>
              </div>
            </template>
          </SOInputRadioSlot>
        </div>
    </template>
  </SOSlotModal>
</template>

<script>
import SOSlotModal from "@/so-components/global/slot/SOSlotModal";
import SOInputRadioSlot from "@/so-components/global/input/SOInputRadioSlot";

export default {
  name: "SnapMesinModalListOutlet",
  props: {
    outlet: Array,
    idOutletSelected: String
  },
  components: {SOInputRadioSlot, SOSlotModal},
  data() {
    return {
      id: "modal-list-outlet"
    }
  },
  methods: {
    close() {
      $("#" + this.id).modal("hide");
      setTimeout(() => {
        this.$emit("close")
      }, 500)
    },
    golistmesin(idoutlet) {
      this.$router.push({
        name: "ListSnapMesin",
        query: {idoutlet: idoutlet}
      });
      this.close()
      this.$emit('selected', idoutlet);
    },
  },
  mounted() {
    $("#" + this.id).modal("show")
  }
}
</script>

<style scoped>
.list-wrapper {
  max-height: 30vh;
  position: relative;
  overflow: auto;
}

.content-radio {
  display: grid;
  grid-template-columns: 40px auto;
  grid-column-gap: 16px;
  align-items: center;
}

.logo {
  width: 40px;
  height: 40px;
  border-radius: 3px;
}
</style>